import { render, staticRenderFns } from "./ClueDetail.vue?vue&type=template&id=0c623c35&"
import script from "./ClueDetail.vue?vue&type=script&lang=js&"
export * from "./ClueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports